var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6492 0.445168L15.5548 2.3508C16.1484 2.94435 16.1484 3.90888 15.5548 4.50635L14.1725 5.88871C14.0241 6.0371 13.782 6.0371 13.6336 5.88871L10.1113 2.36642C9.9629 2.21803 9.9629 1.97592 10.1113 1.82753L11.4937 0.445168C12.0911 -0.148389 13.0556 -0.148389 13.6492 0.445168ZM12.8896 6.60363L9.39637 3.11037C9.24921 2.96321 9.00909 2.96321 8.86193 3.11037L0.403763 11.5685L0.00486593 15.1625C-0.0493531 15.6427 0.357289 16.0494 0.837515 15.9951L4.43146 15.5962L12.8896 7.13807C13.0368 6.99091 13.0368 6.75079 12.8896 6.60363Z",
    fill: "#19C1D6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditpen);
export default __webpack_public_path__ + "static/media/editpen.4d2e9e2eb6090e631e93c346bd57813e.svg";
export { ForwardRef as ReactComponent };